import type { SVGProps } from 'react';

const Arrow = (props: SVGProps<SVGSVGElement>) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M0.2 5.2C0.4 5.4 0.7 5.4 0.9 5.2L4.8 1.3L8.6 5.2C8.8 5.4 9.2 5.4 9.4 5.2C9.6 5 9.6 4.6 9.4 4.4L5.2 0.2C5.1 0.1 4.9 0 4.8 0C4.6 0 4.4 0.1 4.3 0.2L0.1 4.4C-0.1 4.6 -0.1 5 0.2 5.2Z"
            transform="translate(4 6)"
            fill="currentColor"
        />
    </svg>
);

export default Arrow;
